/* global window */
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import { getTrackingType } from '../utils/analytics';

class GoogleAnalytics extends React.Component {
  constructor(props) {
    super(props);
    this.clientInitialized = false;
    this.trackingType = null;
  }

  componentDidMount() {
    if (this.props.clientGA) {
      this.trackingType = getTrackingType(this.props.clientGA);

      if (window.ga || window.gtag) {
        this.initClient();
      } else {
        window.addEventListener('gtm_loaded', () => {
          this.initClient();
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname },
    } = prevProps;

    if (this.props.location.pathname !== pathname) {
      this.trackPageView();

      if (this.props.clientGA) {
        this.initClient();
      }
    }
  }

  trackPageView() {
    const { location } = this.props;
    if (this.trackingType === 'ua') {
      ReactGA.pageview(this.props.location.pathname);
    } else if (this.trackingType === 'ga4') {
      ReactGA4.send({
        hitType: 'pageview',
        page: location.pathname,
      });
    }
  }

  initClient() {
    if (!this.props.clientGA) {
      return;
    }

    if (!this.clientInitialized) {
      this.clientInitialized = true;

      if (this.trackingType === 'ua') {
        ReactGA.initialize(this.props.clientGA, {
          gaOptions: {
            name: 'clientTracker',
          },
        });
      } else if (this.trackingType === 'ga4') {
        ReactGA4.initialize(this.props.clientGA, {
          gaOptions: {
            name: 'clientTracker',
          },
        });
      }
    }

    // Track the current page
    this.trackPageView();
  }

  render() {
    return null;
  }
}

GoogleAnalytics.propTypes = {
  location: PropTypes.object,
  clientGA: PropTypes.string,
};

export default compose(
  withRouter,
  connect(({ theme }) => ({
    clientGA: theme.ga,
  })),
)(GoogleAnalytics);



// WEBPACK FOOTER //
// ./src/client/Components/GoogleAnalytics.js